import {
  type PropsWithChildren,
  type ReactElement,
  type ReactNode,
} from 'react';
import { isElement } from 'react-is';

import type { SpinButtonGroupSeparatorProps } from './types.js';

/**
 * Allows to check if a ReactNode is a SpinButtonGroupSeparator element.
 * @internal
 */
export function isSpinButtonGroupSeparator(
  node: ReactNode,
): node is ReactElement<SpinButtonGroupSeparatorProps> {
  return (
    node !== undefined &&
    node !== null &&
    isElement(node) &&
    node.type === SpinButtonGroupSeparator
  );
}

/**
 * Used to define a trigger between spinbuttons. e.g. the colon within a time value 12:34.
 */
export const SpinButtonGroupSeparator = ({
  children,
  ...props
}: PropsWithChildren<SpinButtonGroupSeparatorProps>) => {
  return <span>{children ?? props.trigger}</span>;
};
